import styled from 'styled-components';

export const WrapperDesktop = styled.span`
  font-size: ${props => props.theme.rem(32)};
  font-weight: 600;
  color: ${props => props.theme.colors.blueDianne};

  span {
    font-size: ${props => props.theme.rem(16)};
    font-weight: 500;
    color: ${props => props.theme.colors.cornFlowerBlue};
  }
`;

export const WrapperMobile = styled(WrapperDesktop)`
  font-size: ${props => props.theme.rem(22)};
`;
